import { render, staticRenderFns } from "./router-manag.vue?vue&type=template&id=1e548270&"
import script from "./router-manag.vue?vue&type=script&lang=js&"
export * from "./router-manag.vue?vue&type=script&lang=js&"
import style0 from "./router-manag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports